// extracted by mini-css-extract-plugin
export default {"stickyHeader":"use-sticky-header-module__stickyHeader--m_lh7"};